import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { TagsMutationKeys } from '../../constants'
import { RemoveTagsFromPlayersDto } from '../../types'
import { removeTagsFromPlayers } from '../services'

interface RemoveTagsFromPlayersParams {
	payload: RemoveTagsFromPlayersDto
}

export default function useMutationRemoveTagsFromPlayers(
	props?: UseBaseMutationOptions<void, RemoveTagsFromPlayersParams>,
) {
	return useMutation({
		mutationKey: [TagsMutationKeys.RemoveTagsFromPlayers],
		mutationFn: (params) => removeTagsFromPlayers(params.payload),
		...props,
	})
}
